export default {
      id: "forbidden-usage",
      viewBox: "0 0 461 372",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#forbidden-usage",
      toString: function () {
        return this.url;
      }
    }